import { FeaturesFullpageBlock } from "../Components/FeaturesScrollSection";
import { OwnerHero } from "../Components/OwnerHero";
import TrackRecord from "../Components/TrackRecord";

export default function Owners() {
  const sections = [
    {
      title: "Innovative Management Technology",
      desc: "We’re a leader in residential property management technology, utilizing software and online portals that offer residents easy and efficient rent collection and maintenance requests. Our clients and tenants enjoy a multitude of online and user-friendly tools including:",
      features: [
        "Online payments",
        "Auto-reminders",
        "Text automation",
        "Maintenance request forms",
        "Electronic doc signing",
        "Online self-scheduling",
      ],
    },
    {
      title: "Leasing Services & Tenant Placement",
      desc: "We will promote your properties and screen prospective residents fairly to ensure we’re matching the right tenant with the right home.",
      features: [
        "Tenant placement",
        "Electronic doc signing",
        "Property transitions",
        "Rent collection",
        "Rental analysis",
        "Estimations",
      ],
    },
    {
      title: "Marketing & Advertising",
      desc: "Frontier uses cutting-edge management technology and the latest marketing strategies to attract the perfect tenants and to drive profit for our clients. Some of our platforms include:",
      features: [
        "Social media marketing",
        "Digital ads and campaigns",
        "Virtual property tours",
        "Syndicated listings across Zillow, Trulia, Zumper, ABODO, and more",
      ],
    },
    {
      title: "Competitive Management Pricing",
      desc: "Frontier is focused on providing the highest quality service to our clients, at the most competitive prices.",
      features: [
        "8–10% management fees (discounts on large portfolios)",
        "Leasing placement/advertising fees = ½ of first month’s rent",
        "$100 flat-rate renewal fee",
        "$55/hour in-house maintenance",
        "No up-charges on vendor invoices",
      ],
    },
    {
      title: "Complete Financial Reporting",
      desc: "Frontier provides clear and transparent reporting in several ways, including owner portal, email, and postal mail on a regular basis. Highlights include:",
      features: [
        "24-hour access to owner portal",
        "Monthly owner statements and reporting",
        "Electronic payment distributions",
        "Detailed monthly reporting",
      ],
    },
  ];

  return (
    <div>
      {/* <OwnerHero /> */}
      <FeaturesFullpageBlock />
      {/* <TrackRecord /> */}
    </div>
  );
}
